export default __webpack_public_path__ + "media/video-bg.e6fe537e.png";